import { useEffect } from 'react';
import { ReactComponent as PageNotFoundIcon2 } from '../../../../assets/PageNotFound2.svg';
import { useLanguage } from '../../../../contexts/languageContext';
import { StepperControls } from '../../../../modules/verificationComponent/VerificationComponent';
import { emitProcessPhase } from '../../../utils/emitData';

type ErrorPageProps = {
  stepper?: StepperControls;
  errorCode?: string;
};

export const ErrorPage = ({ errorCode }: ErrorPageProps) => {
  const { translation } = useLanguage();

  useEffect(() => {
    emitProcessPhase('Error');
  }, []);

  // Get error message based on error code
  const getErrorMessage = () => {
    switch (errorCode) {
      case 'UNEXPECTED_ERROR':
        return {
          title: translation.yeppRegistration.webcomponent.unexpectedError.title,
          description: translation.yeppRegistration.webcomponent.unexpectedError.description,
        };
      default:
        return {
          title: translation.yeppRegistration.webcomponent.unexpectedError.title,
          description: translation.yeppRegistration.webcomponent.unexpectedError.description,
        };
    }
  };
  const { title, description } = getErrorMessage();

  return (
    <div className="onboarding-step">
      <div className="onboarding-step__illustration">
        <PageNotFoundIcon2 />
      </div>
      <h2
        className="onboarding-step__header"
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <p
        className="onboarding-step__description"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  );
};
